import React from 'react';
import Header from './Header';
import Footer from './Footer';

const PremiumPageLayout = ({ children, className = '' }) => {
  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, #020617 0%, #0B1120 100%)' }}>
      <Header />
      <main className={className}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PremiumPageLayout;
